<!-- Backdrop -->
<div class="tg-terms-backdrop" role="dialog" aria-modal="true" aria-labelledby="tg-terms-title">

  <!-- Modal box -->
  <div class="tg-terms-modal">

    <!-- Sticky header -->
    <header class="tg-terms-header">
      <div>
        <div class="tg-terms-eyebrow">TG Empleos · Tec Gurus</div>
        <h2 id="tg-terms-title" class="tg-terms-title">Aviso de privacidad y términos</h2>
      </div>
      <button type="button" class="tg-terms-close" (click)="onCancel()" aria-label="Cerrar">×</button>
    </header>

    <!-- Body scrollable -->
    <div class="tg-terms-body">

      <!-- Layer 1: Resumen de puntos clave -->
      <p class="tg-terms-intro">
        Antes de guardar tu perfil, cargar tu C.V. o postularte, necesitamos tu autorización para tratar tus datos.
        Aquí lo esencial:
      </p>

      <ul class="tg-terms-bullets">
        <li>
          <strong>Datos para empleo.</strong>
          Usaremos tu perfil, contacto y C.V. para crear recomendaciones, hacer match con vacantes y permitirte postular.
        </li>
        <li>
          <strong>Análisis con IA.</strong>
          Procesamos tu C.V. con inteligencia artificial para mejorarlo, extraer información profesional y sugerir vacantes compatibles.
        </li>
        <li>
          <strong>Compartir con empresas.</strong>
          Solo cuando actives <em>"Mostrar mis datos a las empresas"</em> o te postules, tu perfil y C.V. se comparten con reclutadores.
          Puedes desactivarlo en cualquier momento desde tu perfil.
        </li>
        <li>
          <strong>Datos sensibles.</strong>
          Si tu C.V. incluye salud, biométricos u otros datos sensibles, acepta que los proporcionas voluntariamente.
          Te recomendamos no incluirlos si no son necesarios.
        </li>
        <li>
          <strong>Tus derechos ARCO.</strong>
          Puedes solicitar acceso, rectificación, cancelación, oposición o revocar tu consentimiento escribiendo a
          <a href="mailto:empleos@tecgurus.net">empleos&#64;tecgurus.net</a>.
        </li>
        <li>
          <strong>Sin garantías de contratación.</strong>
          TG Empleos es plataforma de vinculación: no garantiza entrevistas, contratación ni resultados específicos.
        </li>
      </ul>

      <!-- Toggle texto completo -->
      <button type="button" class="tg-terms-toggle" (click)="toggleFullText()">
        {{ showFullText ? '▲ Ocultar texto completo' : '▼ Ver texto completo' }}
      </button>

      <!-- Layer 2: Texto legal completo -->
      <div class="tg-terms-fulltext" *ngIf="showFullText">
        <p>
          Al continuar, autorizo a <strong>I.T. Quality Services, S.A. de C.V. — Tec Gurus</strong>, responsable de TG Empleos,
          a recabar, almacenar, consultar, actualizar y utilizar la información que proporcione dentro de la plataforma para fines de
          creación de perfil, búsqueda de empleo, análisis curricular, postulación a vacantes, generación de recomendaciones y contacto
          relacionado con oportunidades laborales.
        </p>
        <p>
          La información que podré proporcionar incluye: nombre, apellidos, fecha de nacimiento, género, fotografía, correo electrónico,
          número de WhatsApp, país, zona horaria, especialización, salario deseado, disponibilidad para viajar, disponibilidad para
          mudarme, redes sociales, historial académico, experiencia laboral, certificaciones, habilidades, idiomas, nivel de conocimientos,
          descripción profesional, C.V. y cualquier otro dato que capture voluntariamente dentro de TG Empleos.
        </p>
        <p>
          Acepto que TG Empleos podrá utilizar mi información y mi C.V. para analizar mi perfil profesional, mejorar mi C.V. con
          herramientas de inteligencia artificial, identificar vacantes compatibles con mi experiencia, mostrar recomendaciones
          personalizadas, generar coincidencias con oportunidades laborales y enviarme alertas o notificaciones relacionadas con empleos,
          postulaciones, suscripción, planes o servicios de la plataforma.
        </p>
        <p>
          Autorizo que TG Empleos pueda procesar mi información mediante herramientas tecnológicas propias o de terceros,
          incluyendo servicios de inteligencia artificial, con la finalidad de analizar mi C.V., extraer información profesional,
          mejorar la presentación de mi perfil, generar recomendaciones, comparar mi perfil con vacantes disponibles y ofrecer una
          mejor experiencia dentro de la plataforma.
        </p>
        <p>
          Acepto que, cuando active la opción <em>"Mostrar mis datos a las empresas"</em>, cuando me postule a una vacante o cuando
          utilice funciones de vinculación laboral dentro de TG Empleos, mi perfil, información profesional, datos de contacto y C.V.
          podrán ser compartidos con empresas, reclutadores, clientes, aliados comerciales o posibles empleadores, nacionales o
          extranjeros, exclusivamente para fines de reclutamiento, evaluación de perfiles, contacto laboral, entrevistas,
          seguimiento de postulaciones o vinculación con oportunidades de empleo.
        </p>
        <p>
          Reconozco que puedo desactivar la opción <em>"Mostrar mis datos a las empresas"</em> desde mi perfil, sin perjuicio de que
          la información previamente enviada en postulaciones o procesos de reclutamiento ya iniciados pueda haber sido consultada
          por las empresas o reclutadores correspondientes.
        </p>
        <p>
          Declaro que la información que proporcione es veraz, actual, completa y de mi titularidad. Me comprometo a no cargar
          información falsa, documentos de terceros, datos que no me pertenezcan o contenido que vulnere derechos de otras personas.
        </p>
        <p>
          Reconozco que mi C.V. puede contener información personal adicional a la solicitada por TG Empleos. En caso de incluir
          datos personales sensibles, como información de salud, discapacidad, origen étnico, creencias, opiniones políticas,
          información sindical, datos biométricos, orientación sexual u otros datos sensibles, acepto que dichos datos fueron
          proporcionados voluntariamente por mí y otorgo mi consentimiento expreso para que sean tratados únicamente en la medida
          necesaria para el uso de mi C.V. y mi perfil laboral. Se recomienda no incluir datos sensibles que no sean necesarios
          para procesos de reclutamiento.
        </p>
        <p>
          Entiendo que TG Empleos es una plataforma de apoyo, análisis, recomendación y vinculación laboral, por lo que el uso del
          servicio no garantiza entrevistas, contratación, respuesta de empresas, aceptación en vacantes ni resultados específicos
          en procesos de selección.
        </p>
        <p>
          Mis datos personales podrán conservarse mientras mi cuenta permanezca activa, mientras exista una relación de uso con la
          plataforma o durante el tiempo necesario para cumplir con finalidades legales, administrativas, de seguridad, soporte,
          historial de postulaciones o atención de solicitudes. Podré solicitar la eliminación, cancelación u oposición al
          tratamiento de mis datos conforme al Aviso de Privacidad vigente.
        </p>
        <p>
          Podré ejercer mis derechos de acceso, rectificación, cancelación u oposición, así como revocar mi consentimiento,
          enviando una solicitud al correo
          <a href="mailto:empleos@tecgurus.net">empleos&#64;tecgurus.net</a> o
          <a href="mailto:contacto@tecgurus.net">contacto&#64;tecgurus.net</a>,
          indicando mi nombre completo, correo registrado y el derecho que deseo ejercer.
        </p>
        <p>
          Al aceptar estos términos, confirmo que he leído y acepto el
          <a [href]="privacyUrl" target="_blank" rel="noopener">Aviso de Privacidad de Tec Gurus</a>,
          los presentes términos complementarios de TG Empleos y autorizo el tratamiento de mis datos personales y C.V. para las
          finalidades descritas.
        </p>
      </div>

      <!-- Links rápidos -->
      <div class="tg-terms-links">
        <a [href]="privacyUrl" target="_blank" rel="noopener">📄 Aviso de Privacidad de Tec Gurus</a>
        <a routerLink="/terminos" target="_blank">📋 Términos de TG Empleos</a>
      </div>

      <!-- Contacto -->
      <div class="tg-terms-contact">
        <p class="tg-terms-contact-title">📬 Contacto del responsable</p>
        <p>Av. Chapultepec 473 Piso 2, Col. Juárez, CDMX</p>
        <p>
          <a [href]="'mailto:' + contactEmail">{{ contactEmail }}</a>
          · +52 55 52 11 69 31
        </p>
        <a [href]="mapsUrl" target="_blank" rel="noopener" class="tg-terms-map-btn">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>
          Ver en Google Maps
        </a>
      </div>

    </div>

    <!-- Sticky footer -->
    <footer class="tg-terms-footer">
      <label class="tg-terms-checkbox">
        <input type="checkbox" [(ngModel)]="acceptedCheckbox" [disabled]="saving">
        <span>
          Acepto el Aviso de Privacidad y autorizo a TG Empleos a tratar mis datos personales,
          perfil profesional y C.V. para análisis con IA, recomendaciones de vacantes, postulaciones,
          alertas de empleo y vinculación con empresas o reclutadores.
        </span>
      </label>

      <div *ngIf="errorMsg" class="tg-terms-error">{{ errorMsg }}</div>

      <div class="tg-terms-actions">
        <button type="button" class="tg-btn-secondary" (click)="onCancel()" [disabled]="saving">
          Cancelar
        </button>
        <button type="button" class="tg-btn-primary"
                (click)="onAccept()"
                [disabled]="!acceptedCheckbox || saving">
          {{ saving ? 'Guardando...' : 'Acepto y continuar' }}
        </button>
      </div>
    </footer>

  </div>
</div>
